import request from 'sb-request'
import { reducers } from 'redux/core'

import brandQuery from './brand.graphql'


const reset = () => reducers.view.brandPage.set({})

const fetch = (slug) => request.post('graphql?name=products', {
  body: {
    query: brandQuery,
    variables: {
      slug,
    },
  },
  withErrorModal: false,
  modifyResult: ({ brandBySlug }) => brandBySlug || {},
})
  .then(
    (result) => {
      reducers.view.brandPage.set(result)
      return result
    },
    () => {
      reset()
      return {}
    }
  )


export default {
  reset,
  fetch,
}
